import { render, staticRenderFns } from "./ComplaintFiling.vue?vue&type=template&id=274ffb36&scoped=true&"
import script from "./ComplaintFiling.vue?vue&type=script&lang=js&"
export * from "./ComplaintFiling.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintFiling.vue?vue&type=style&index=0&id=274ffb36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ffb36",
  null
  
)

export default component.exports